import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import classes from '@nerdwallet/base-styles/classes';
import { Link, Type } from '@nerdwallet/currency';

import grnhseTrackingCheck from '../../../lib/company-content-src/grnhse-tracking-check';

const CompanyJobListTile = ({
  id,
  title,
  jobLocation,
  location,
  relativePath,
}) => (
  <div className="joblist__tile--cont">
    <Link
      href={grnhseTrackingCheck(relativePath, location.search)}
      color="neutral-darkest"
      key={title}
    >
      <div
        key={id}
        className={classNames([
          'joblist__tile',
          classes('display-flex'),
          classes('flex-direction-column'),
          classes('flex-direction-row--wide'),
          classes('justify-content-space-between--wide'),
          classes('align-items-center--wide'),
          classes('border-bottom-1'),
          classes('border-neutral-lighter'),
          classes('padding-vertical-3'),
          classes('padding-vertical-4--wide'),
        ])}
      >
        {title && (
          <Type size="3" chronicle className={classNames(['joblist__header'])}>
            {title}
          </Type>
        )}
        <div>
          <Type default size="2" className={classNames(['joblist__jobs'])}>
            {jobLocation}
          </Type>
        </div>
      </div>
    </Link>
  </div>
);

CompanyJobListTile.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  jobLocation: PropTypes.string,
  location: PropTypes.object,
  relativePath: PropTypes.string,
};

CompanyJobListTile.displayName = 'Company Job List Tile';

const CompanyJobListTileWithRouter = withRouter(CompanyJobListTile);

export default CompanyJobListTileWithRouter;
